import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminContext } from "./AdminShell";

/**
 * Wrap admin pages with an allowed-roles guard. Silently redirects to the
 * Executive Dashboard when the current admin doesn't have permission.
 * Frontend safety net — the backend already enforces via require_admin_role.
 */
export const RequireAdminRole = ({ allowed, children }) => {
    const ctx = useAdminContext();
    const role = ctx?.me?.admin_role;
    const roles = ctx?.me?.admin_roles || [];
    const held = new Set([role, ...roles].filter(Boolean));
    // While /admin/me is still loading, render children (backend will 401/403 safely)
    if (held.size === 0) return children;
    if (held.has("platform_admin")) return children;
    if ((allowed || []).some((r) => held.has(r))) return children;
    return <Navigate to="/admin" replace />;
};
